import React, { FC } from 'react'
import { Toolbar, ToolbarProps } from '@mui/material'

const EvtToolbar: FC<ToolbarProps> = ({ children, ...props }) => {
    return <Toolbar {...props}>{children}</Toolbar>
}

export default EvtToolbar
